module.exports = __webpack_public_path__ + "assets/img/df86edc695ee991749a630737797ced0.svg";